/**
 * setDeviceType.js
 * Written by: Alex Kasemir
 */


export const setDeviceType = (config) => ({
  type: `SET_DEVICE_TYPE`,
  config,
});

export default setDeviceType;
